import { Stack } from '@mui/material';
import { SelectColumnFilter } from '@/component/Table/filter/SelectColumnFilter';
import type { ExtendedColumnDef } from '@/component/Table/types';
import EquipmentChip from '@/feature/equipment/EquipmentChip';
import type { ReportRow } from '../types';
import {
  EquipmentFilter,
  equipmentFilterFn,
  type EquipmentOption,
} from './EquipmentFilter';

export const columnDefs: ExtendedColumnDef<ReportRow>[] = [
  {
    accessorKey: 'periodLabel',
    headerText: (texts) => texts.rms.reports.model.period,
    Filter: SelectColumnFilter,
    filterFn: 'equals',
    sortFn: (a, b) =>
      a.original.period.from.localeCompare(b.original.period.from),
  },
  {
    accessorKey: 'reportTypeName',
    headerText: (texts) => texts.rms.reports.model.type.title,
    Filter: SelectColumnFilter,
  },
  {
    accessorKey: 'customer.name',
    headerText: (texts) => texts.rms.reports.model.company,
    Filter: SelectColumnFilter,
  },
  {
    accessorKey: 'site.name',
    headerText: (texts) => texts.rms.reports.model.site,
    Filter: SelectColumnFilter,
  },
  {
    accessorKey: 'equipment',
    enableSorting: false,
    headerText: (texts) => texts.rms.reports.model.equipment,
    Filter: EquipmentFilter,
    filterFn: equipmentFilterFn,
    meta: {
      filterLabel: (value) =>
        (value as EquipmentOption | undefined)?.name ?? '',
    },
    cell: ({ getValue }) => (
      <Stack direction="row" useFlexGap flexWrap="wrap" gap={1}>
        {getValue<ReportRow['equipment']>().map(({ equipmentId, name }) => (
          <EquipmentChip key={equipmentId} value={name} />
        ))}
      </Stack>
    ),
  },
];
